// import { db } from "../../firebase";
// import { doc, getDoc } from "firebase/firestore";

// export const getAuthor = async (id) => {
//     return await getDoc(doc(db, `authors/${id}`)).then((snap) => snap.data());
// }

import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";

export const getAuthor = async (id) => {
  return await getDoc(doc(db, `authors/${id}`)).then((snap) => snap.data());
};

export const getAllAuthors = async () => {
  const snapshot = await getDocs(collection(db, "authors"));
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};
